<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <div v-if="alerta" class="m-auto">
        <b-alert show :variant="variante"> {{ mensagem }} </b-alert>
      </div>
      <form @submit.prevent="submit">
        <div class="row">
          <b-form-group
            label="Locadora"
            invalid-feedback="campo obrigatório"
            class="col-md-4 mb-3"
            :state="state('cdPessoa')"
          >
            <multiselect
              v-model="veiculo.cdPessoa"
              placeholder="Selecione"
              :show-labels="false"
              label="nm_fantasia"
              :options="empresas"
              :custom-label="
                ({ nm_fantasia, nr_cgc_cpf }) =>
                  `${nm_fantasia} [${$tools.converterCnpj(nr_cgc_cpf)}]`
              "
            />
          </b-form-group>

          <b-form-group
            label="Placa"
            invalid-feedback="Por favor, preencha este campo."
            class="col-md-2 mb-3"
          >
            <b-form-input
              v-model.trim="veiculo.nrPlaca"
              v-mask="'AAA#N##'"
              placeholder="Placa"
              class="text-uppercase"
              :disabled="isDisabled"
              :state="state('nrPlaca')"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Ano Fabricação"
            invalid-feedback="Por favor, preencha este campo."
            class="col-md-2 mb-3"
            :state="state('dtAnoFabricacao')"
          >
            <date-picker
              v-model.trim="veiculo.dtAnoFabricacao"
              type="year"
              placeholder="0000"
              value-type="YYYY"
              :disabled-date="(date) => date >= new Date()"
            >
            </date-picker>
          </b-form-group>

          <b-form-group
            label="KM Odômetro"
            valid-feedback="Campo preenchido"
            invalid-feedback="Por favor, preencha este campo corretamente."
            class="col-md-2 mb-3"
          >
            <b-form-input
              for="kmInicial"
              v-model.trim="veiculo.kmInicial"
              placeholder="0"
              :state="state('kmInicial')"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Ativo" class="col-md-1 mb-3">
            <div class="d-flex">
              <b-form-radio
                v-model="veiculo.stAtivo"
                value="S"
                :disabled="!isDisabled"
                plain
                class="me-2"
                >Sim</b-form-radio
              >
              <b-form-radio
                v-model="veiculo.stAtivo"
                value="N"
                :disabled="!isDisabled"
                plain
                >Não</b-form-radio
              >
            </div>
          </b-form-group>

          <b-form-group
            label="Marca"
            valid-feedback="Campo preenchido"
            invalid-feedback="Por favor, preencha este campo corretamente."
            class="col-md-4 mb-3"
            :state="state('cdMarca')"
          >
            <multiselect
              v-model="veiculo.cdMarca"
              track-by="cd_marca"
              label="nm_marca"
              placeholder="Selecione uma Marca"
              :show-labels="false"
              :options="marcas"
              @input="filtraCategoria()"
            >
              <template slot="noResult">
                <span>Nenhum resutado encontrado!</span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group
            label="Categoria"
            valid-feedback="Campo preenchido"
            invalid-feedback="Por favor, preencha este campo corretamente."
            class="col-md-4"
            :state="state('cdCategoria')"
          >
            <multiselect
              v-model="veiculo.cdCategoria"
              track-by="cd_categoria"
              label="nm_categoria"
              placeholder="Selecione uma categoria"
              :show-labels="false"
              :options="categorias"
              @input="filtroSelect()"
            >
              <template slot="noResult">
                <span>Nenhum resutado encontrado!</span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group
            label="Modelo"
            valid-feedback="Campo preenchido"
            invalid-feedback="Por favor, preencha este campo corretamente."
            class="col-md-4 mb-3"
            :state="state('sqModelo')"
          >
            <multiselect
              v-model="veiculo.sqModelo"
              track-by="sq_modelo"
              label="nm_modelo"
              placeholder="Selecione um modelo"
              :show-labels="false"
              :options="modelos"
            >
              <template slot="noOptions">
                <span>Nenhum resutado encontrado!</span>
              </template>
              <template slot="noResult">
                <span>Nenhum resutado encontrado!</span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group
            label="Observação"
            label-for="observacao"
            class="col-12 md-3"
          >
            <b-form-textarea
              for="observacao"
              v-model="veiculo.dsObs"
              placeholder="Observações"
              :maxlength="200"
            ></b-form-textarea>
            <div class="text-center">
              <p
                v-if="veiculo.dsObs"
                class="badge position-absolute"
                :class="{
                  'bg-success': veiculo.dsObs.length !== 200,
                  'bg-danger': veiculo.dsObs.length === 200,
                }"
              >
                {{ veiculo.dsObs.length }} / 200
              </p>
            </div>
          </b-form-group>
        </div>

        <div class="d-flex justify-content-between mt-3">
          <div class="d-grid gap-2 d-md-flex justify-content-md-start">
            <router-link to="/locadora/veiculo">
              <button class="btn btn-light" type="button">Cancelar</button>
            </router-link>
          </div>
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button class="btn btn-primary" type="submit">{{ button }}</button>
            <b-button @click="limpar()">
              <i class="mdi mdi-broom font-size-16 align-middle me-2"></i>
              Limpar
            </b-button>
          </div>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import {
  required,
  minLength,
  maxLength,
  numeric,
  alphaNum,
} from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  components: {
    PageHeader,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      title: "Cadastrar Veículo",
      button: "Cadastrar",
      alerta: false,
      veiculos: "",
      post: false,
      isDisabled: "",
      mensagem: "",
      variante: "",
      veiculo: {
        nrPlaca: "",
        dtAnoFabricacao: "",
        kmInicial: "",
        stAtivo: "S",
        cdCategoria: "",
        cdMarca: "",
        sqModelo: "",
        dsObs: "",
        cdPessoa: "",
      },
      dados: {
        cdPessoa: "",
        nrPlaca: "",
        dtAnoFabricacao: "",
        kmInicial: "",
        stAtivo: "S",
        cdCategoria: "",
        cdMarca: "",
        sqModelo: "",
        dsObs: "",
        sqUsuario: "",
        cdTpPessoa: "",
        id: "",
      },
      categorias: [],
      categoriaAuxiliar: [],
      marcas: [],
      marcaAuxiliar: [],
      modelos: [],
      empresas: [],
      modeloAuxiliar: [],
      items: [
        {
          text: "Locadora",
          active: false,
        },
        {
          text: "Listagem de Veículos",
          href: "/locadora/veiculo",
        },
        {
          text: "Cadastro Veículo",
          active: true,
        },
      ],
    };
  },
  async created() {
    this.isDisabled = false;

    this.$http.get("api/veiculo").then((response) => {
      this.auxVeiculos = response.data;
    });

    this.$http.get("api/veiculo/categoria").then((response) => {
      this.categorias = response.data;
    });

    this.$http.get("api/veiculo/marca").then((response) => {
      this.marcas = response.data;
    });

    this.$http.get("api/veiculo/modelo").then((response) => {
      this.modelos = response.data;
    });

    this.empresas = await this.$tools.filtroTomador.buscarEmpresas();

    this.$http.get("api/auth/me").then((response) => {
      this.dados.sqUsuario = response.data.sq_usuario;
      this.dados.cdTpPessoa = "2";
    });

    if (this.$route.params.id != "add") {
      //VERIFICANDO SE É UM NOVO CADASTRO OU UMA EDIÇÃO PELO ID NA ROTA
      this.title = "Editar veiculo";
      this.button = "Salvar";
      this.$http
        .get("api/veiculo/" + this.$route.params.id)
        .then((response) => {
          //preparando as variávels auxiliares, é nescessário para que o component de multiselect funcione de maneira desejada
          this.categoriaAuxiliar.push({
            cd_categoria: response.data.cd_categoria,
            nm_categoria: response.data.nm_categoria,
          });
          this.marcaAuxiliar.push({
            cd_marca: response.data.cd_marca,
            nm_marca: response.data.nm_marca,
          });
          this.modeloAuxiliar.push({
            sq_modelo: response.data.sq_modelo,
            nm_modelo: response.data.nm_modelo,
          });

          //jogando o valor recebido da requisição nos v-model dos inputs da tela
          this.dados.id = response.data.nr_placa;
          this.veiculo.nrPlaca = response.data.nr_placa;
          this.veiculo.dtAnoFabricacao = response.data.dt_ano_fabricacao;
          this.veiculo.kmInicial = response.data.qt_km_inicial;
          this.veiculo.stAtivo = response.data.st_ativo;
          this.veiculo.cdMarca = this.marcaAuxiliar[0];
          this.veiculo.cdCategoria = this.categoriaAuxiliar[0];
          this.veiculo.sqModelo = this.modeloAuxiliar[0];
          this.veiculo.dsObs = response.data.ds_obs;
          var pessoa = this.empresas.find(
            (el) => el.cd_pessoa == response.data.cd_pessoa
          );
          this.veiculo.cdPessoa = pessoa;
          this.isDisabled = true;
        });
    }
  },
  validations: {
    veiculo: {
      nrPlaca: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(7),
        alphaNum,
      },
      dtAnoFabricacao: {
        required,
      },
      kmInicial: {
        required,
        numeric,
      },
      cdCategoria: {
        required,
      },
      cdMarca: {
        required,
      },
      sqModelo: {
        required,
      },
      cdPessoa: {
        required,
      },
    },
  },

  methods: {
    submit() {
      this.post = true;
      this.preencheDadosEnvio();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.$route.params.id !== "add") {
          //VERIFICANDO SE EDIÇÃO OU ADIÇÃO PELO ID NA ROTA
          this.editarVeiculo();
        } else {
          this.adicionarVeiculo();
        }
      }
    },

    preencheDadosEnvio() {
      this.dados.nrPlaca = this.veiculo.nrPlaca;
      this.dados.dtAnoFabricacao = this.veiculo.dtAnoFabricacao;
      this.dados.kmInicial = this.veiculo.kmInicial;
      this.dados.stAtivo = this.veiculo.stAtivo;
      this.dados.cdCategoria = this.veiculo.cdCategoria.cd_categoria;
      this.dados.cdMarca = this.veiculo.cdMarca.cd_marca;
      this.dados.sqModelo = this.veiculo.sqModelo.sq_modelo;
      this.dados.dsObs = this.veiculo.dsObs;
      this.dados.cdPessoa = this.veiculo.cdPessoa.cd_pessoa;
      return;
    },

    adicionarVeiculo() {
      this.$http
        .post("api/veiculo", this.dados)
        .then(() => {
          this.montaMensagem("success", "Veiculo cadastrado com sucesso!");
          this.limpar();
        })
        .catch((error) => {
          this.montaMensagem("danger", error.response.data.message);
        });
    },

    editarVeiculo() {
      this.$http
        .put("api/veiculo/" + this.dados.id, this.dados)
        .then(() => {
          this.$store.commit("ENVIAR_NOTIFICACAO", {
            notificacao: "Veiculo editado com sucesso!",
            icone: "success",
          });
          this.$router.push("/locadora/veiculo");
        })
        .catch((error) => {
          this.montaMensagem("danger", error.response.data.message);
        });
    },

    filtroSelect() {
      this.veiculo.sqModelo = "";
      if (
        this.veiculo.cdCategoria.cd_categoria &&
        this.veiculo.cdMarca.cd_marca
      ) {
        this.$http
          .get(
            "api/veiculo/modeloPorCategoriaAndMarca/" +
              this.veiculo.cdCategoria.cd_categoria +
              "/" +
              this.veiculo.cdMarca.cd_marca
          )
          .then((response) => {
            this.modelos = response.data;
          });
      }
    },

    montaMensagem(variante, mensagem) {
      this.alerta = true;
      this.variante = variante;
      this.mensagem = mensagem;
    },

    filtraCategoria() {
      var aux = [];
      var cdMarca = this.veiculo.cdMarca.cd_marca;
      this.categorias = this.auxVeiculos.filter((item) => {
        if (
          cdMarca === parseInt(item.cd_marca) &&
          !aux.includes(item.cd_categoria)
        ) {
          aux.push(item.cd_categoria);
          return true;
        } else {
          return false;
        }
      });
      this.veiculo.cdCategoria = "";
      this.veiculo.sqModelo = "";
      this.filtroSelect();
    },

    state(param) {
      if (this.post) {
        return !this.$v.veiculo[param].$invalid;
      } else {
        return null;
      }
    },

    limpar() {
      if (this.$route.params.id === "add") {
        this.veiculo.nrPlaca = "";
        this.dados.nrPlaca = "";
      }
      this.veiculo.dtAnoFabricacao = "";
      this.veiculo.kmInicial = "";
      this.veiculo.cdMarca = "";
      this.veiculo.cdCategoria = "";
      this.veiculo.sqModelo = "";
      this.veiculo.dsObs = "";
      this.veiculo.cdPessoa = "";

      this.dados.dtAnoFabricacao = "";
      this.dados.kmInicial = "";
      this.dados.cdMarca = "";
      this.dados.cdCategoria = "";
      this.dados.sqModelo = "";
      this.dados.dsObs = "";
    },
  },
};
</script>

<style>
.is-valid .multiselect__tags {
  border-color: #34c38f !important;
}
.is-invalid .multiselect__tags {
  border-color: #f46a6a !important;
}

.is-valid .mx-input {
  border-color: #34c38f !important;
}

.is-invalid .mx-input {
  border-color: #f46a6a !important;
}
</style>